import React from 'react'

import api from '../../../../api'
import { authHeader } from '../../../../_helpers/auth-header'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

function DrawerForm({ action, setAction }) {
    const {
        data: { id, title, content, color_hex },
        behavior,
    } = action

    const initialState = {
        title: behavior === 'update' ? title : '',
        content: behavior === 'update' ? content : '',
        color_hex: behavior === 'update' ? color_hex : '',
    }

    const [form, setForm] = React.useState({ ...initialState })
    const [isError, setIsError] = React.useState(null)

    function handleChange({ target }) {
        const { id, value } = target
        setForm({ ...form, [id]: value })
    }

    function update(id) {
        api.put(
            `/notices/${id}`,
            {
                title: form.title,
                content: form.content,
                color_hex: form.color_hex,
            },
            { authHeader }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAction({
                        ...action,
                        behavior: '',
                        drawer: false,
                    })
                }
            })
            .catch((error) => {
                let message =
                    typeof error.response !== 'undefined'
                        ? error.response.data.message
                        : error.message
                setIsError(message)
            })
    }

    function create() {
        api.post(
            '/notices',
            {
                title: form.title,
                content: form.content,
                color_hex: form.color_hex,
            },
            { authHeader }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAction({
                        ...action,
                        behavior: '',
                        drawer: false,
                    })
                }
            })
            .catch((error) => {
                let message =
                    typeof error.response !== 'undefined'
                        ? error.response.data.message
                        : error.message
                setIsError(message)
            })
    }

    function handleSubmit(e) {
        e.preventDefault()

        if (behavior === 'create') {
            create()
            return
        }

        if (behavior === 'update') {
            update(id)
            return
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <span className="form-group mb-4 d-block">
                <label>Título</label>
                <input
                    className="form-control"
                    id="title"
                    type="text"
                    onChange={handleChange}
                    value={form.title}
                    required
                />
            </span>

            <span className="form-group mb-4 d-block">
                <label>Descrição</label>
                <CKEditor
                    id="editor"
                    editor={ClassicEditor}
                    config={{
                        toolbar: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'link',
                            'bulletedList',
                            'numberedList',
                            'blockQuote',
                        ],
                    }}
                    data={form.content}
                    onChange={(event, editor) => {
                        const data = editor.getData()
                        setForm({ ...form, content: data.toString() })
                    }}
                />
            </span>

            <span className="form-group mb-4 d-block">
                <label>Título</label>
                <div className="d-flex align-items-center">
                    <input
                        className="form-control p-0 me-2"
                        id="color_hex"
                        type="color"
                        style={{
                            width: '36px',
                            height: '36px',
                            borderColor: 'transparent',
                        }}
                        onChange={handleChange}
                        value={form.color_hex}
                        required
                    />
                    <input
                        className="form-control"
                        id="color_hex"
                        type="text"
                        value={form.color_hex}
                        disabled
                        required
                    />
                </div>
            </span>

            <span className="form-group">
                <button className="btn btn-primary">
                    {behavior === 'create' ? 'Salvar' : 'Atualizar'}
                </button>
            </span>

            {isError && (
                <div className="row">
                    <div className="col">
                        <p className="mt-2 bg-danger text-white rounded p-3">
                            {isError[Object.keys(isError)]}
                        </p>
                    </div>
                </div>
            )}
        </form>
    )
}

export default DrawerForm
